import { c as _c } from "react/compiler-runtime";
import { type SVGProps } from "react";
export function IconReadaloud(props) {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M6.2959 12.6312C7.14994 11.7153 8.18258 10.9842 9.33011 10.4828C10.4776 9.98148 11.7157 9.72057 12.968 9.7162C14.2202 9.71183 15.4601 9.96408 16.6111 10.4574C17.7621 10.9507 18.7998 11.6746 19.6602 12.5845M8.97753 15.1318C9.48995 14.5823 10.1095 14.1436 10.7981 13.8428C11.4866 13.542 12.2294 13.3855 12.9808 13.3828C13.7321 13.3802 14.4761 13.5316 15.1667 13.8276C15.8573 14.1236 16.4799 14.5579 16.9961 15.1038" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />;
    t1 = <path d="M20.9161 19.73H17.8867C16.8823 19.73 16.3791 19.73 15.9233 19.8685C15.5197 19.991 15.145 20.1917 14.8192 20.4595C14.4511 20.762 14.1722 21.1799 13.615 22.0157L13 22.9382L12.3781 22.0055C11.8255 21.1765 11.5484 20.7608 11.1818 20.4595C10.8559 20.1917 10.4794 19.991 10.0759 19.8685C9.61998 19.73 9.1179 19.73 8.11346 19.73H5.08398" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props) {
    t2 = <svg width="26" height="26" viewBox="0 3 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}{t1}</svg>;
    $[2] = props;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}